// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/map-pinned.js';

import { paths } from '../generated/map-pinned';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('map-pinned', Original, paths);
